import React, { ChangeEvent, useContext, useEffect, useRef } from 'react';
import { useRecoilValue } from 'recoil';
import { DataContext } from 'entries/common/widgets/context';
import { useCalculationState } from 'pages/calculation/store/calculation';
import { gaImpressionsProduct } from 'ga-events/ga-impressions-product';
import {
  tintServiceIsAnyColorsSelected,
  useInitTintServiceState,
} from 'pages/calculation/store/tint-service';
import { MainProduct as MainProductCommon } from 'pages/common/components/MainProduct';
import { MainProductBlock } from './styles';
import { SelectTintColor } from './SelectTintColor';
import { Coloring } from './Coloring';

export const MainProductComponent = () => {
  const productRef = useRef<HTMLDivElement>(null);
  const data = useContext(DataContext);
  const isAnyColorsSelected = useRecoilValue(tintServiceIsAnyColorsSelected);
  const { calculationFormState, setCalculationState, calculatedPrice } = useCalculationState();
  const handleChangeCounter = (_event: ChangeEvent<HTMLInputElement>, value: string): void => {
    setCalculationState(prevState => ({
      ...prevState,
      count: value,
    }));
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) {
          gaImpressionsProduct({
            name: data?.displayedName ?? '',
            id: data?.productId ?? '',
            price: `${data?.mainPrice ?? 0}`,
            position: '1',
          });
        }
      },

      {
        threshold: 0.5,
      }
    );

    if (productRef.current) {
      observer.observe(productRef.current);
    }

    return () => {
      if (productRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(productRef.current);
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps -- Нужно послать только один раз
  }, []);

  useInitTintServiceState();

  return (
    <MainProductBlock ref={productRef}>
      <MainProductCommon
        photo={data?.photo}
        displayedName={data?.displayedName}
        productId={data?.productId}
        count={calculationFormState.count}
        price={calculatedPrice}
        onChangeCounter={handleChangeCounter}
        selectTintColorComponent={data?.isTintAvailable ? <SelectTintColor /> : undefined}
        priceUnitsLabel="₽ / шт."
      />
      {isAnyColorsSelected && <Coloring />}
    </MainProductBlock>
  );
};
